import React, { useEffect } from "react";
import FormGroup from "../../FormGroup";

import style from "../style.module.css";
import { getIcon } from "../../../../helpers/icons";

export function Layout(props) {
    const {
        prompt = "Please select...",
        input: { value, onChange, name },
        meta,
        label,
        loaded,
        disabled,
        list = [],
        allLabel = false,
        required = false,
        autoSelect = false,
        selectValue = () => { },
        onChangeHandler = () => { }
    } = props

    useEffect(() => {
        if (autoSelect && list.length === 1 && !disabled) {
            onChange(list[0].id.toString())
        }
    }, [autoSelect, list, disabled, onChange]);

    const values = disabled ? selectValue(list, loaded) : value || prompt;
    return (
        <FormGroup
            meta={meta}
            label={label}
            inputType="dropdown"
            value={values}
            disabled={disabled}
            required={required}
            fieldName={name}
            fieldValue={value || ""}
        >
            <div className={`${style.selectBox}`}>
                {
                    list.length > 0 && (
                        <span className={style.icon}>
                            <i className={getIcon('Triange')}></i>
                        </span>
                    )
                }
                <span className={style.selectedText}>{selectValue(list, loaded)}</span>
                <select className={style.select} value={value} onChange={(e) => onChangeHandler(e, list)}>
                    {
                        (list.length > 1 || autoSelect === false) && (
                            <>
                                <option value="">{prompt}</option>
                                {
                                    allLabel !== false && list.length !== 1 && (
                                        <option value="all">{allLabel}</option>
                                    )
                                }
                            </>
                        )
                    }
                    {
                        list.length > 0 && list.map((option, index) => (
                            <option value={option.id} key={`${label}'s_option_${index}`}>{option.name}</option>
                        ))
                    }
                </select>
            </div>
        </FormGroup>
    )
}